const BillingReportMenu = [
  {
    icon: "call_received_icon",
    key: "billing.inbound.gateway",
    name: "Inbound Gateway Report",
    url: "home/app/billing/inbound-gateway-report",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
  },
  {
    icon: "summarize_icon",
    key: "billing.inbound.gateway.summary",
    name: "Inbound Gateway Summary",
    url: "home/app/billing/inbound-gateway-summary",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
  },
  {
    icon: "call_made_icon",
    key: "billing.outbound.gateway",
    name: "Outbound Gateway Report",
    url: "home/app/billing/outbound-gateway-report",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
  },
  {
    icon: "summarize_icon",
    key: "billing.outbound.gateway.summary",
    name: "Outbound Gateway Summary",
    url: "home/app/billing/outbound-gateway-summary",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
  },
  {
    icon: "display_settings_icon",
    key: "billing.inbound.extension.detail",
    name: "Inbound Extension Details",
    url: "home/app/billing/inbound-extension-detail",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
  },
  {
    icon: "extension_icon",
    key: "billing.inbound.extension.summary",
    name: "Inbound Extension  Summary",
    url: "home/app/billing/inbound-extension-summary",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
  },

  {
    icon: "display_settings_icon",
    key: "billing.outbound.extension.detail",
    name: "Outbound Extension Details",
    url: "home/app/billing/outbound-extension-detail",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
  },
  {
    icon: "schedule_icon",
    key: "billing.scheduled.reports",
    name: "Scheduled Reports",
    url: "home/app/billing/scheduled-reports",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
  },
  {
    icon: "extension_icon",
    key: "billing.outbound.extension.summary",
    name: "Outbound Extension  Summary",
    url: "home/app/billing/outbound-extension-summary",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
  },
  {
    icon: "assessment_icon",
    key: "department.wish.summary",
    name: "Department Wise Summary Report",
    url: "home/app/department-wise-summary-report",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
    disabled: false,
  },
  {
    icon: "assessment_icon",
    key: "department.wish.detailed",
    name: "Department Wise Detailed Report",
    url: "home/app/department-wise-detailed-report",
    description: "",
    productionReady: true,
    demoReady: false,
    testingReady: false,
    disabled: false,
  },
];

export { BillingReportMenu };
